import { useFormContext } from 'react-hook-form';
import { OnboardingXeroEntities } from './XeroEntitiesForm';
import { AlertV2, StandardAlert } from '@cimplico/components';
import { formatSummaryMessages } from '../utils';

function OnboardingSummaryBanner(): JSX.Element {
    const { watch } = useFormContext<OnboardingXeroEntities>();

    const values = watch('connections');

    return <AlertV2 type="info" title="Onboarding Summary" description={formatSummaryMessages(values)} className="mb-4" />;
}

export default OnboardingSummaryBanner;
